module.exports = __webpack_public_path__ + "img/gender-equality.c943cd77.png";